import React from 'react';

import type {RunSetPart} from '../../state/views/runSet/types';
import * as Query from '../../util/queryts';
import type {GroupSelectionState} from '../../util/selectionmanager';
import {ProjectPicker} from '../ProjectPicker/ProjectPicker';
import {RunsSearchBar} from '../RunsSearchBar';
import {useRunSelectorFeatureEnabled} from './RunSelectorFeaturesContext';
import {useRunSelectorProjectInfo} from './RunSelectorRunSetContext';

type RunSelectorExtraTableActionsTop = {
  addToHistory: (query: string, isRegex?: boolean | undefined) => void;
  enableSetProject: boolean;
  groupSelections: GroupSelectionState;
  onSetSearch: (query: string, isRegex: boolean) => void;
  runSet: RunSetPart;
  setProject: (
    newEntityName: string,
    newProjectName: string,
    newProjectId: string
  ) => void;
};

export function RunSelectorExtraTableActionsTop(
  props: RunSelectorExtraTableActionsTop
) {
  const isEnabled = useRunSelectorFeatureEnabled();
  const {projectName, entityName, projectInternalId} =
    useRunSelectorProjectInfo();

  return (
    <>
      {props.enableSetProject && projectInternalId && (
        <ProjectPicker
          entityName={entityName}
          projectName={projectName}
          setProject={props.setProject}
          projectId={projectInternalId}
        />
      )}
      {isEnabled('search') ? (
        <div style={{flexGrow: 1}}>
          <RunsSearchBar
            isGroupSearch={Query.isGroupedByGroup(
              props.groupSelections.grouping
            )}
            search={{
              query: props.runSet.search.query,
              isRegex: props.runSet.search.isRegex ?? true,
            }}
            setSearch={props.onSetSearch}
            searchHistory={props.runSet.searchHistory}
            onAddToHistory={props.addToHistory}
          />
        </div>
      ) : null}
    </>
  );
}
